export default __webpack_public_path__ + "static/media/Head_4_Ear_2_C2.a251acf0.svg";